var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95898 6.96552L2.1314 11.7931C1.99347 11.931 1.83255 12 1.64864 12C1.46473 12 1.30381 11.931 1.16588 11.7931C1.02795 11.6552 0.958984 11.4943 0.958984 11.3103C0.958984 11.1264 1.02795 10.9655 1.16588 10.8276L5.99347 6L1.16588 1.17241C1.02795 1.03448 0.958984 0.873563 0.958984 0.689655C0.958984 0.505747 1.02795 0.344828 1.16588 0.206897C1.30381 0.0689655 1.46473 0 1.64864 0C1.83255 0 1.99347 0.0689655 2.1314 0.206897L6.95898 5.03448L11.7866 0.206897C11.9245 0.0689655 12.0854 0 12.2693 0C12.4532 0 12.6142 0.0689655 12.7521 0.206897C12.89 0.344828 12.959 0.505747 12.959 0.689655C12.959 0.873563 12.89 1.03448 12.7521 1.17241L7.9245 6L12.7521 10.8276C12.89 10.9655 12.959 11.1264 12.959 11.3103C12.959 11.4943 12.89 11.6552 12.7521 11.7931C12.6142 11.931 12.4532 12 12.2693 12C12.0854 12 11.9245 11.931 11.7866 11.7931L6.95898 6.96552Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.35de94769013769f628319533a3560ed.svg";
export { ForwardRef as ReactComponent };